const FEMALE_HINTS = ['female', 'zira', 'aria', 'jenny', 'samantha', 'karen', 'susan', 'victoria', 'kate', 'moira', 'tessa', 'fiona', 'nova', 'ava', 'emma', 'amy', 'anna', 'sara', 'ivy', 'joanna', 'salli'];
const MALE_HINTS = ['male', 'david', 'mark', 'guy', 'alex', 'daniel', 'fred', 'george', 'james', 'thomas', 'diego', 'oliver', 'brian', 'matthew', 'ryan', 'ivan'];

const PRIORITY = {
  female: ['microsoft zira', 'microsoft aria', 'microsoft jenny', 'zira', 'aria', 'jenny'],
  male: ['microsoft david', 'microsoft mark', 'microsoft guy', 'david', 'mark', 'guy'],
};

export const normalizeClientGender = (value) => {
  const gender = typeof value === 'string' ? value.trim().toLowerCase() : '';
  if (gender === 'female' || gender === 'woman') return 'female';
  if (gender === 'male' || gender === 'man') return 'male';
  return null;
};

export const inferVoiceGender = (voice) => {
  const name = String(voice?.name || '').toLowerCase();
  if (FEMALE_HINTS.some((hint) => name.includes(hint))) return 'female';
  if (MALE_HINTS.some((hint) => name.includes(hint))) return 'male';
  return null;
};

/** Returns a browser voice object, or null to retain the existing default voice. */
export const getRoleplayVoiceForClientGender = (clientGender, availableVoices) => {
  const gender = normalizeClientGender(clientGender);
  if (!gender || !Array.isArray(availableVoices)) return null;
  const matches = availableVoices.filter((voice) =>
    String(voice?.lang || '').toLowerCase().startsWith('en') && inferVoiceGender(voice) === gender
  );
  if (!matches.length) return null;
  const priorities = PRIORITY[gender];
  for (const candidate of priorities) {
    const match = matches.find((voice) => String(voice.name || '').toLowerCase().includes(candidate));
    if (match) return match;
  }
  return matches[0];
};
